import styled from '@emotion/styled/macro';
import { Box } from '@chakra-ui/react';

export const Wrapper = styled(Box)`
  margin: 81px -15px 0;
`;
